import { useCallback } from 'react'

import { getV6ApiUrl } from '@/utils/urlHelpers'

export interface PolicyDocumentResponse {
  data: {
    content: string
    category: string
    brand_id: string
  }
  status: string
  code: number
}

export interface PolicyDocumentError {
  error: string
  valid_categories?: string[]
}

export type PolicyDocumentCategory = 'Privacy' | 'Terms' | 'Partner Agreement Terms' | 'Claims'

const usePolicyDocumentApi = (): {
  fetchPolicyDocument: (
    brandId: string,
    category: PolicyDocumentCategory,
  ) => Promise<PolicyDocumentResponse>
} => {
  const fetchPolicyDocument = useCallback(
    async (brandId: string, category: PolicyDocumentCategory): Promise<PolicyDocumentResponse> => {
      const url = getV6ApiUrl(`/policy_documents/${category}?brand_id=${brandId}`)

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-brand-id': brandId,
        },
      })

      if (!response.ok) {
        const errorData: PolicyDocumentError = await response.json()
        throw new Error(errorData.error || 'Failed to fetch policy document')
      }

      return response.json()
    },
    [],
  )

  return {
    fetchPolicyDocument,
  }
}

export default usePolicyDocumentApi
